import axios from "axios";

export default class SugestoesLegislacaoApi {
  constructor() {
    this.api = axios.create({
      baseURL: `${process.env.VUE_APP_BASE_API_URL}/api/v1`,
    });
  }

  create(sugestao) {
    return this.api.post("/sugestoes_legislacao", {
      sugestao_legislacao: sugestao,
    });
  }
}
